import template from './views/component.tpl.html';
import './controllers/component-controller';

/**
 * @ngdoc component
 * @name navigation.component:navigation-topnav
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example <navigation-topnav></navigation-topnav>
 *
 */
angular
    .module('festzelt-os.components')
    .component('navigationTopNav', {
        restrict: 'E',
        templateUrl: template,
        replace: false,
        controllerAs: 'vm',
        controller: 'TopNavComponentController',
        bindings: {
            navIsMobile: '='
        }
    });



// WEBPACK FOOTER //
// ./src/app/components/navigation/components/topnav/topnav-component.js